import { CopyIcon } from "@/components/CopyIcon";
import { cn, createBEM } from "@/libs";
import "./index.scss";

export const CopyIconInput = ({value}: {value:string}) => {
  const b = createBEM('i-formcopyicon');
  return value ? <div className={cn(b())}>
    <div className={cn(b('text'))}>{value}</div>
  <CopyIcon text={value}/></div> : undefined
}